@if (jsonLd) {
    <website-json-ld [json]="jsonLd"></website-json-ld>
}
<div
    class="breadcrumbs"
    [class.breadcrumbs--left-gradient]="showLeftGradient()"
    [class.breadcrumbs--right-gradient]="showRightGradient()"
    data-application="breadcrumbs-container"
>
    <ol
        #breadcrumbsList
        class="breadcrumbs__wrapper"
        websiteTheme
        [colorScheme]="colorScheme()"
        (scroll)="onScroll()"
        data-application="breadcrumbs-list"
    >
        @for (breadcrumb of breadcrumbs(); track breadcrumb) {
            @if (breadcrumb && !breadcrumb.forJsonLd) {
                <li class="breadcrumbs__item" data-application="breadcrumbs-item">
                    @if (breadcrumb.link) {
                        <a href="{{ breadcrumb.link }}" class="breadcrumbs__link" data-application="breadcrumbs-link">{{
                            breadcrumb.text | translate
                        }}</a>
                    } @else {
                        <span class="breadcrumbs__text" data-application="breadcrumbs-link">{{
                            breadcrumb.text | translate
                        }}</span>
                    }
                </li>
            }
        }
    </ol>
</div>
